/**
 * Tira o tier do fim do nome de uma área.
 *
 * <p>Por um tempo o time escreveu a faixa de tier no próprio nome — "Mata das
 * Serpentes - T3-4-5", "Tau t1-2". Os nomes foram limpos no GG Pilot em 07/08/2026,
 * então hoje isto quase não faz nada.
 *
 * <p>Fica como rede: o nome é campo livre, e no dia em que alguém voltar a anotar o
 * tier ali, o mapa continua mostrando só o nome — o tier já está no selo ao lado, e as
 * duas coisas juntas seriam informação repetida e, quando discordassem, contraditória.
 *
 * <p>Só corta no <b>fim</b> do nome, e só o que parece faixa de tier. "Vale das 3
 * lâminas" não perde o 3, e "T5 Ruínas" não perde nada — sufixo é sufixo.
 */
const SUFIXO_DE_TIER = /\s*[-–—]?\s*t\s?-?\s?[1-5](?:\s?-\s?[1-5])*\s*$/i;

export function semTier(nome: string): string {
  return nome.replace(SUFIXO_DE_TIER, '').trim() || nome;
}

/**
 * Quebra o nome da área para o hexágono: <b>duas linhas sempre que houver duas
 * palavras</b>.
 *
 * <p>Antes a quebra era por contagem de caracteres, e o mapa saía desalinhado: "Campos
 * de Trigo" cabia numa linha e "Rochedos Cantantes" não, então os dois hexágonos
 * vizinhos tinham o nome em alturas diferentes e o selo de tier em posições diferentes.
 * Num mapa de 21 células iguais, isso lê como defeito.
 *
 * <p>Com a regra por palavra, todo hexágono tem a mesma caixa de texto — e a altura do
 * bloco deixa de depender de quantas letras o nome tem.
 *
 * <p>O corte busca o <b>ponto mais equilibrado</b>: "Campos | de Trigo" (6 e 8) em vez de
 * "Campos de | Trigo" (9 e 5). Linhas de tamanhos parecidos centralizam melhor e evitam
 * a segunda linha órfã de uma palavra curta.
 */
export function linhasDoNome(nome: string): string[] {
  const palavras = nome.trim().split(/\s+/).filter(Boolean);
  if (palavras.length <= 1) return palavras.length ? palavras : [nome];

  let melhor = 1;
  let menorDiferenca = Infinity;
  for (let corte = 1; corte < palavras.length; corte++) {
    const esquerda = palavras.slice(0, corte).join(' ').length;
    const direita = palavras.slice(corte).join(' ').length;
    const diferenca = Math.abs(esquerda - direita);
    if (diferenca < menorDiferenca) {
      menorDiferenca = diferenca;
      melhor = corte;
    }
  }

  return [palavras.slice(0, melhor).join(' '), palavras.slice(melhor).join(' ')];
}
